import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Filters } from '../common/Filters';

toast.configure();
export const Option = memo((props) => {
  const { item, filters, removeOption } = props;
  const [editable, setEditable] = useState(false);
  // 初期設定
  const [currentOption, setCurrentOption] = useState(item);
  const [currentOptionTransJa, setCurrentOptionTransJa] = useState([]);
  const [currentOptionTransEn, setCurrentOptionTransEn] = useState([]);
  useEffect(() => {
    currentOption.translations_attributes.map(tran => {
      if (tran.locale === "ja") {
        setCurrentOptionTransJa(tran);
      } else {
        setCurrentOptionTransEn(tran);
      }
    });
  }, []);

  const onChangeCode = e => setCurrentOption({ ...currentOption, code: e.target.value });
  const onChangeEnabled = () => setCurrentOption({ ...currentOption, enabled: !currentOption.enabled });
  const onChangeJa = e => setCurrentOptionTransJa({ ...currentOptionTransJa, name: e.target.value });
  const onChangeJaDesc = e => setCurrentOptionTransJa({ ...currentOptionTransJa, description: e.target.value });
  const onChangeEn = e => setCurrentOptionTransEn({ ...currentOptionTransEn, name: e.target.value });
  const onChangeEnDesc = e => setCurrentOptionTransEn({ ...currentOptionTransEn, description: e.target.value });
  // codeフォーム設定
  let codeDecorate = editable ?
      <td>
        <input type="number" className="form-control" defaultValue={currentOption.code} onChange={onChangeCode} />
      </td>
      :
      <td>{currentOption.code}</td>;
  // 日本語ラベル・備考フォーム設定
  let nameJaDecorate = editable ? 
      <td>
          <input type="text" className="form-control" defaultValue={currentOptionTransJa.name} onChange={onChangeJa} />
          <input type="text" className="form-control" defaultValue={currentOptionTransJa.description} onChange={onChangeJaDesc} />
      </td>
      :
      <td>
        {currentOptionTransJa.name}
        <br/>
        {(!currentOptionTransJa.description) ? "" : `(${currentOptionTransJa.description})`}
      </td>;
  // 英語ラベル・備考フォーム設定
  let nameEnDecorate = editable ? 
      <td>
          <input type="text" className="form-control" defaultValue={currentOptionTransEn.name} onChange={onChangeEn} />
          <input type="text" className="form-control" defaultValue={currentOptionTransEn.description} onChange={onChangeEnDesc} />
      </td>
      :
      <td>
        {currentOptionTransEn.name}
        <br/>
        {(!currentOptionTransEn.description) ? "" : `(${currentOptionTransEn.description})`}
      </td>;

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  // edit 失敗時のデータ設定
  const setOldData = (item) => {
    setCurrentOption({ ...currentOption, code: item.code });
    item.translations_attributes.map(oldTran => {
      if (oldTran.locale === "ja") {
        setCurrentOptionTransJa({
          ...currentOptionTransJa,
          name: oldTran.name,
          description: oldTran.description
        });
      } else {
        setCurrentOptionTransEn({
          ...currentOptionTransEn,
          name: oldTran.name,
          description: oldTran.description
        });
      }
    });
  }

  const onClickEditSubmit = (id) => {
    if (!currentOption.code || !currentOptionTransJa.name || !currentOptionTransEn.name) {
      alert("※入力必須です。");
      return
    }

    if (editable) {
      let mod_item = {item: {
        code: currentOption.code,
        translations_attributes: [
          { id: currentOptionTransJa.id, locale: "ja", name: currentOptionTransJa.name.trim(), description: currentOptionTransJa.description.trim() },
          { id: currentOptionTransEn.id, locale: "en", name: currentOptionTransEn.name.trim(), description: currentOptionTransEn.description.trim() }
        ]
      }}

      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.patch(`/agent/options/${id}`, mod_item)
      .then(resp => {
        console.log(resp);
        notify("success", "Option successfully updated!");
      })
      .catch(e => {
        console.log(e.response);
        setOldData(item);
        alert(JSON.parse(e.request.responseText).errors);
        notify("error", "Option update Error!");
      })
    }
    setEditable(!editable);
  }

  const onClickEnableSubmit = (id) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.put(`/agent/options/${id}/enabled`)
    .then(resp => {
      onChangeEnabled();
      notify("success", "Option Enabled successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Option Enabled update Error!");
    })
  }

  const onClickDeleteSubmit = (id) => {
    const sure = window.confirm('Are you sure?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/agent/options/${id}`)
      .then(resp => {
        console.log(resp);
        removeOption(id);
        notify("success", "Option successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "Option delete Error!");
      })
    }
  }

  return (
    <tr>
      {codeDecorate}
      {nameJaDecorate}
      {nameEnDecorate}
      <td>
        <div>
          <button onClick={() => onClickEditSubmit(currentOption.id)} className={editable ? 'btn btn-primary' : 'btn btn-outline-dark'} title="Edit" disabled={(!currentOption.code || !currentOptionTransJa.name || !currentOptionTransEn.name)}>
            <i className="far fa-edit" />
          </button>
          <button onClick={() => onClickDeleteSubmit(currentOption.id)} className='btn btn-outline-danger mx-1' title="Delete" disabled={(editable)}>
            <i className="far fa-trash-alt" />
          </button>
          <button onClick={() => onClickEnableSubmit(currentOption.id)} className={currentOption.enabled ? 'btn btn-outline-info' : 'btn btn-warning'} title="En/Disabled">
            <i className={currentOption.enabled ? 'fas fa-bell' : 'fas fa-bell-slash'} />
          </button>
        </div>
      </td>
      <td>
        <Filters model_id={currentOption.id}
          modelName="options"
          filters={filters}
          using_filter_ids={currentOption.using_filter_ids} />
      </td>
    </tr>
  );
});
